import Label from './label';
import app from '../../public-api';

app.plugins.register({
  name: 'us:label',

  extends: 'viewport',

  dependencies: ['us:user-config'],

  constructor: Label
});



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/label/label-loader.js